import Helpers, {
  BROKERAGE_UNDER_RATE,
  BROKERAGE_OVER_RATE,
  INTRA_DAY_RATE,
  MIN_BROKERAGE,
  CLEARING_FEE,
  MAX_CLEARING,
  STAMP_DUTY,
  STAMP_DUTY_MAX,
  SST_CHARGE,
  STAMP_DUTY_WARRANT,
  STAMP_DUTY_WARRANT_MAX,
} from "../utils/Helper";
import _ from "lodash";

export const INITIAL_DATA = {
  brokerage_under_rate: BROKERAGE_UNDER_RATE,
  brokerage_over_rate: BROKERAGE_OVER_RATE,
  min_brokerage: MIN_BROKERAGE,
  clearing_fee_rate: CLEARING_FEE * 100,
  intraday_rate: INTRA_DAY_RATE,
  sst: SST_CHARGE * 100,
  list:[]
};

export default function (state = INITIAL_DATA, action) {
  switch (action.type) {
    case "UPDATE_NEW_MOVEMENT_SUCCESS":
      return {
        ...state,
        newObject: action.data,
      };
    case "UPDATE_EXISTING_MOVEMENT_SUCCESS":
      return {
        ...state,
        existingObject: action.data,
      };
    case "ADD_NEW_MOVEMENT_REQUEST":
      return {
        ...state,
        isSuccessUpdated: false,
      };
    case "ADD_NEW_MOVEMENT_SUCCESS":
      const list = !_.isEmpty(state.list) ? state.list.concat(action.data) : [action.data];

      return {
        ...state,
        list: _.orderBy(list, ["created_at"], ["desc"]),
        isSuccessUpdated: true,
      };
    case "ADD_NEW_MOVEMENT_FAILURE":
      return {
        ...state,
        isSuccessUpdated: false,
      };
    case "DELETE_MOVEMENT_REQUEST":
      return {
        ...state,
        messages: null,
      };
    case "DELETE_MOVEMENT_SUCCESS":
      let listData = Object.assign([], state.list);
      const updatedData = listData.filter((element, index) => index !== action.id);

      return {
        ...state,
        list: updatedData,
      };
    case "DELETE_MOVEMENT_FAILURE":
      return {
        ...state,
        messages: action.messages,
        isSuccessUpdated: false,
      };
    case "PUT_UPDATE_MOVEMENT_REQUEST":
      return {
        ...state,
        messages: null,
        isSuccessUpdated: false,
      };
    case "PUT_UPDATE_MOVEMENT_SUCCESS":
      let updateMovementList = Object.assign([], state.list);
      updateMovementList[action.index] = action.data;
      return {
        ...state,
        list: updateMovementList,
        isSuccessUpdated: true,
      };
    case "PUT_UPDATE_MOVEMENT_FAILURE":
      return {
        ...state,
        isSuccessUpdated: false,
        messages: action.messages,
      };
    case "REHYDRATE_MOVEMENT_STATE_SUCCESS":
      return {
        ...state,
        list: action.data && action.data.list ? action.data.list : [],
      };
    case "ADD_NEW_TEMPLATE_SUCCESS":
      const index = _.findIndex(state.templates, { name: action.data.name });
      let templates = Object.assign([], state.templates);
      if (_.isEmpty(templates)) {
        templates = [action.data];
      } else if (index !== -1) {
        templates[index] = action.data;
      } else {
        templates = templates.concat(action.data);
      }
      return {
        ...state,
        templates: _.orderBy(templates, ["created_at"], ["desc"]),
      };

    case "DELETE_TEMPLATE_SUCCESS":
      let templateList = Object.assign([], state.templates);
      const templateUpdateData = templateList.filter((element, index) => index !== action.id);
      return {
        ...state,
        templates: templateUpdateData,
      };
    case "IMPORT_TEMPLATE_SUCCESS":
      const templateData = _.get(state.templates, action.id, {});
      const clientInput = {
        mof: templateData.mof,
        outstanding_amount: templateData.outstanding_amount,
        margin_value: templateData.margin_value,
        market_value: templateData.market_value,
      };
      return {
        ...state,
        clientInput: clientInput,
        list: templateData.share_movement_list,
      };
    case "ADD_EXISTING_MOVEMENT" :
      const existingList = state.list

      const newList = _.filter(existingList,item=>{
          return !_.get(item,['is_existing'],false)
        })
        const newResultList = !_.isEmpty(action.data) && !_.isEmpty(newList) ? action.data.concat(newList) : !_.isEmpty(action.data) ? action.data : newList
      return {...state,list:newResultList}
    default:
      return state;
  }
}
